'use client'

import { DatePickerInputProps, DateTimePicker as MantineDateTimePicker, DateValue } from '@mantine/dates'
import { useLocale } from 'next-intl'

const DATE_FORMAT_DEFAULT = 'DD.MM.YYYY HH:mm'

type TDate = DateValue | undefined

type TProps = {
  onValueChange?: (value: TDate) => void
} & DatePickerInputProps

export const DateTimePicker: React.FC<TProps> = ({
  onValueChange,
  onChange,
  dropdownType = 'popover',
  w = '100%',
  value,
  minDate,
  ...props
}) => {
  const locale = useLocale()

  const handleChange = (date: TDate) => {
    onValueChange?.(date)
    onChange?.(date as DateValue)
  }

  return (
    <MantineDateTimePicker
      dropdownType={dropdownType}
      locale={locale}
      minDate={minDate}
      onChange={handleChange}
      value={value}
      valueFormat={DATE_FORMAT_DEFAULT}
      highlightToday
      w={w}
      size={props.size || 'md'}
      {...props}
    />
  )
}
